import { Route, Routes } from "react-router-dom";
import FooterBase from "./FooterBase";
import FooterWithHomeBtn from "./FooterWithHomeBtn";
import FooterOnlyBuyBtn from "./FooterOnlyBuyBtn";

const Footer = () => {

    return (

        <Routes>
            <Route  path='/' element={<FooterBase />} />
            <Route  path='/wallet' element={<FooterBase selected={'wallet'} />} />
            <Route  path='/auth_err' element={<FooterBase />} />
            <Route  path='/profile' element={<FooterBase selected={'profile'} />} />
            <Route  path='/shops/:title/:cat' element={<FooterBase />} />
            <Route  path='/withdraw' element={<FooterBase />} />
            
            {/* <Route  path='/shop/:shop' element={<FooterOnlyBuyBtn />} /> */}
            
            <Route  path='/charge-wallet' element={<FooterWithHomeBtn />} />
            <Route  path='/edit_profile' element={<FooterWithHomeBtn />} />
            <Route  path='/tutorial' element={<FooterWithHomeBtn />} />
            <Route  path='/rules' element={<FooterWithHomeBtn />} />
            <Route  path='/support' element={<FooterWithHomeBtn />} />
            <Route  path='/transfer' element={<FooterWithHomeBtn />} />
            <Route  path='/transfer/search' element={<FooterWithHomeBtn />} />
            <Route  path='/barcode_generate' element={<FooterWithHomeBtn />} />
            <Route  path='/buy' element={<FooterWithHomeBtn />} />
            <Route  path='/installments' element={<FooterWithHomeBtn />} />
            <Route  path='/installments/search' element={<FooterWithHomeBtn />} />
            <Route  path='/installments/barcode' element={<FooterWithHomeBtn />} />
            <Route  path='/installments/upload-factor' element={<FooterWithHomeBtn />} />
            <Route  path='/transfer/branch' element={<FooterWithHomeBtn />} />
        </Routes>

    );
}

export default Footer;